  <template>
  <div :key="configureTrigger" class="launchpad-containers p-3" :class="`deferred-content${loading ? ' loading' : ''}`">
    <div v-if="autostartContainer.state==='up'">
      <i class="pi pi-sync pi-spin"/> Sie werden weitergeleitet: <a href="#" @click.prevent="gotoSubdomain(autostartContainer,autostartHomeUrl)">{{autostartContainer.APP_SUBDOMAIN}}</a>
    </div>
    <div v-else-if="autostartContainer.id">
      <i class="pi pi-sync pi-spin"/> Ihre Anwendung wird gestartet
    </div>
    <div v-else>
      ERROR
    </div>
  </div>
</template>

<script>
import AuthGuestView from "@/components/AuthGuestView.vue";
import containersService from "@/containers-service";
import {singletons} from "../../shared";

export default {
  extends: AuthGuestView,
  name: 'AutostartView',
  components: {
  },
  props: {
    msg: String,
    container: String
  },
  data() {
    return {
      listContainers:[],
      profile:{},
      initArgs:{},
      selectedImage:{},
      mapLabels:{
        "APP_USER":"Benutzername",
        "ADMIN_PWD":"Passwort"
      },
      configureTrigger:1,
      isGuest:false,
      loading:true,
      mapDisplaySettingsEditor: {},
      image:"_default",
      autostartContainer:{},
      autostartHomeUrl:""
    }
  },
  async created() {
    this.profile = await this.deferred;
    if (!this.profile)
      this.$router.push("/login");
    this.isGuest = this.profile.username?.match(/^guest_/);
    await containersService.autostart();
    let containers = await this.loadContainers();
    this.image = process.env.VUE_APP_AUTOSTART_CONTAINER_IMAGE || this.image;
    containers = containers.filter(container=>container.APP_IMAGE===this.image)
    if (containers.length>0) {
      this.autostartContainer = containers[0];
      this.autostartHomeUrl = process.env.VUE_APP_AUTOSTART_HOME_URL || this.autostartHomeUrl;
      if (this.autostartContainer.state==='up')
          this.gotoSubdomain(this.autostartContainer, this.autostartHomeUrl);
    }
    this.attachWebsocketHandlers();
    this.loading = false;
  },
  methods:{
    goto(path="/") {
      this.$router.push(path);
    },
    async loadContainers() {
      this.listContainers = (await containersService.index({},"self")).data||[];
      return this.listContainers;
    },
    attachWebsocketHandlers() {
      for (let node of Object.keys(singletons.sockets)) {
        singletons.sockets[node].off('onContainersUp').on('onContainersUp', (listIds) => {
          if (listIds.indexOf(this.autostartContainer.id)>-1) {
            this.autostartContainer.state="up";
            setTimeout(()=>this.gotoSubdomain(this.autostartContainer,this.autostartHomeUrl),500);
          }
        })
        singletons.sockets[node].off('onContainersDown').on('onContainersDown', (listIds) => {
          if (listIds.indexOf(this.autostartContainer.id))
            this.autostartContainer.state="down"
        });
        singletons.sockets[node].off('onContainersDestroy').on('onContainersDestroy', async (listContainers) => {
          if (listContainers.map(({id})=>id).indexOf(this.autostartContainer.id)) {
            this.autostartContainer = {};
            this.configureTrigger++;
          }
        })
      }
    },
    gotoSubdomain(data,url="") {
      let {root,nodes} = singletons.cluster;
      let node = data.node || (nodes?.length ? nodes[0] : "m01");
      let targetHostUrl = root ? `${node}.${root}` : window.location.hostname;
      window.location.href = `${window.location.protocol}//${data.EXTERNAL_FQDN ? data.EXTERNAL_FQDN : `${data.APP_SUBDOMAIN}.${targetHostUrl}`}${url}`;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
ul>li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
ol { counter-reset: item; padding:0; line-height: 1.75;
  display: flex; flex-direction: column }
ol>li { display: flex; flex-direction: row }
ol>li:before {
  content: counter(item) ".\00a0\00a0";
  counter-increment: item;
  display: inline-block;
}
</style>
